<template>
  <div>
    <div
      class="searchButton"
      @click="dialogVisible = true"
    >
      <i class="el-icon-search" />
      搜索
    </div>
    <div
      class="re-max-search"
      @click="dialogVisible = false"
      v-if="dialogVisible"
    >
      <div
        class="re-max-search-cont"
        @click.stop
      >
        <div class="re-max-search_moudle">
          <input
            type="text"
            v-model.trim="keyword"
            placeholder="输入关键词查询"
            @keyup.enter="search"
          />
          <button @click="search">搜 索</button>
        </div>
      </div>

    </div>

  </div>

</template>

<script>
export default {
  name: 'EventHeaderSearch',
  // beforeRouteEnter (to, from, next) {
  //   // 已经登陆时请求用户信息
  //   if (store.getters.logged) {
  //     store.dispatch('GetUserinfo')
  //       .then(res => {
  //         next()
  //       })
  //   } else {
  //     next()
  //   }
  // },
  data () {
    return {
      keyword: '',
      dialogVisible: false
    }
  },
  watch: {
    '$route.params' () {
      this.keyword = this.$route.params.keyword
    }
  },
  methods: {
    search () {
      if (!this.keyword) {
        return false
      }
      this.$router.push({
        name: 'EventSearch',
        params: {
          keyword: this.keyword
        }
      })
      this.dialogVisible = false
    }
  }
}
</script>
<style lang="scss" scoped>
.re-max-search {
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 60px;
  right: 0;
  bottom: 0;
  z-index: 99;
  background-color: rgba(0, 0, 0, 0.5);
  .re-max-search-cont {
    width: 1240px;
    margin: 0 auto;
    background: #ffffff;
    padding: 40px 0 38px 0;

    .re-max-search_moudle {
      position: relative;
      display: flex;
      align-items: center;
      margin: 0 auto;
      width: 760px;
      height: 42px;

      .go-index {
        line-height: 1;

        .re-logo {
          width: 158px;
        }
      }

      input {
        flex: 1 1;
        // margin-left: 30px;
        height: 42px;
        padding: 0 16px;
        border-radius: 4px 0 0 4px;
        border: solid 1px #cccccc;
        font-size: 14px;
        transition: all 0.4s;
        outline: none;

        // &:focus {
        //   border: 1px solid #4551c2;
        // }
      }

      input::-webkit-input-placeholder {
        color: #cccccc;
      }

      input:-moz-placeholder {
        /* Mozilla Firefox 4 to 18 */
        color: #cccccc;
      }

      input::-moz-placeholder {
        /* Mozilla Firefox 19+ */
        color: #cccccc;
      }

      input:-ms-input-placeholder {
        /* Internet Explorer 10+ */
        color: #cccccc;
      }

      button {
        width: 108px;
        height: 42px;
        background: #1f72f2;
        border-radius: 0px 4px 4px 0px;
        vertical-align: bottom;
        color: #ffffff;
        font-size: 16px;
        font-weight: 600;
        transition: all 0.4s;

        &:hover {
          background: #1f72f2;
        }
      }
    }
  }
}
.searchButton {
  margin-right: 20px;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  width: 90px;
  height: 30px;
  color: #666;
  cursor: pointer;
  user-select: none;
  background: #fff;
  border-radius: 20px;
  & > i {
    font-size: 18px;
    color: #1f72f2;
    font-weight: bold;
  }
}
.search {
  margin-right: 30px;
  border-bottom: 1px solid #ddd;
  width: 240px;
  display: flex;
  flex-flow: row nowrap;
  height: 22px;
  line-height: 22px;
  color: #fff;

  input {
    flex: 1;
    background: transparent;
    border: none;
    outline: none;
    text-indent: 4px;

    &::placeholder {
      color: #bbb;
      font-size: 14px;
    }
  }

  button {
    width: 35px;
    background: transparent;
    border: none;
    color: #cccccc;
    font-size: 1.2em;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/index/components/EventHeaderSearch.vue